<template>
	<div style="min-height:600px;">
		<figure style="text-align: center;margin-top:100px;" v-if="list.length==0">
			<img src="@/assets/kong.png" alt="" srcset="" />
			<figcaption>暂无数据</figcaption>
		</figure>
		<div class="orderbox">
			<div v-for="(i,index) in list" :key="index" class="liebiao1" @click="datails(i.o_id)">
				<div class="orderTitle">
					<h3>{{i.demand.name}}</h3>
					<span style="color:#FF0000;" v-if="i.status==0">待需方付款</span>
					<span style="color:#4DC800;" v-if="i.status==1 || i.status==2 || i.status==3 || i.status==4">进行中</span>
					<span style="color:#FF5900;" v-if="i.status==5 && i.demand_score==0">待评价</span>
					<span style="color:#FF0000;" v-if="i.status==-1">已取消</span>
					<span style="color:#1E3A8A;" v-if="i.status==5 && i.demand_score>0">已完成</span>
					<span style="color:#FF0000;" v-if="i.status==-2">已退款</span>
			<!-- 		<span style="color:#FF5900;" v-if="i.type==6">已收藏</span> -->
				</div>
				<div class="orderbh1">订单编号：{{i.order_sn}}</div>
				<div class="orderbh2"><span>服务方：</span>{{i.serveUser.nickname}}</div>
				<div class="orderbh3"><span>中标金额：</span>￥{{i.total_price}}</div>
				
				
				<div v-if="i.type==2" class="orderbh4">
					<div class="orderbh4_1">留言</div>
				</div>
				
				<div v-if="i.status==1 || i.status==2 || i.status==3 || i.status==4" class="orderbh4">
					<div class="orderbh4_1" @click.stop="liuyan(i.o_id,i.status)" style="position:relative;">
						留言
						<div v-if="i.unread_message_count>0" 
						      style="
							    width:20rpx;
								height:20rpx;
								background-color:red;
								position: absolute;
								border-radius:50%;
								top: -12rpx;right: -32rpx;">
						</div>
					</div>
					<div v-if="i.has_review=='true'" class="orderbh4_2" @click.stop="pingshen(i.o_id)">查看评审</div>
				</div>
				
				<div v-if="i.status==-2" class="orderbh4">
					<div @click.stop="liuyan(i.o_id,5)" v-if="i.message_count>0" class="orderbh4_2">查看留言</div>
					<div v-if="i.has_review=='true'" class="orderbh4_2" @click.stop="pingshen(i.o_id)">查看评审</div>
				</div>
				
				<div v-if="i.status==0" class="orderbh4">
					<div class="orderbh4_1" @click.stop="pay(i)">立即支付</div>
				</div>
				<div v-if="i.status==5" class="orderbh4">
					<div v-if="i.has_review=='true'" class="orderbh4_2" @click.stop="pingshen(i.o_id)">查看评审</div>
					<div @click.stop="liuyan(i.o_id,5)" v-if="i.message_count>0" class="orderbh4_2">查看留言</div>
					<div v-if="i.is_invoice>0" class="orderbh4_2" @click.stop="chakana(i.o_id)">查看开票</div>
					<div class="orderbh4_1" v-if="i.is_invoice==0" @click.stop="kaipiao(i.o_id)">开票</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="开票"
		  :visible.sync="centerDialogVisible"
		  :close-on-click-modal="false"
		  width="430px"
		  >
		  <div>
			  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				  <el-form-item label="公司信息" prop="company_name">
					<el-input v-model="ruleForm.company_name"></el-input>
				  </el-form-item>
				  <el-form-item label="公司税号" prop="tax_id">
					<el-input v-model="ruleForm.tax_id"></el-input>
				  </el-form-item>
				  <el-form-item label="发票金额">
				  	 <el-input v-model="invoice_price" disabled></el-input>
				  </el-form-item>
				  <el-form-item label="邮箱信息" prop="email">
				  	<el-input v-model="ruleForm.email"></el-input>
				  </el-form-item>
				</el-form>
		  </div>
		  <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center;">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="微信支付"
		  :visible.sync="payDialogVisible"
		  :close-on-click-modal="false"
		  width="750px"
		  >
		  <div>
			  <div class="pay-tip"><h3>扫码支付</h3><span>打开手机端微信APP扫一扫支付</span></div>
			  <div class="pay-box">
				  <LinkQrCode :link="payLink" :size="120" />
				  <div class="pay-box1">
					  <p>剩余支付时间：<CountDown :endTime="paybox.auto_cancel_time*1000"></CountDown></p>
					  <div class="pay-box2">
						  <h4>支付金额</h4>
						  <span>￥{{paybox.total_price}}</span>
					  </div>
				  </div>
			  </div>
			  
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import LinkQrCode from '@/common/LinkQrCode.vue'
	import {
		invoicePrice,
		InvoiceApply,
		personal,
		OrderPay,
		payStatus
	} from "@/api/api.js"
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components: {
		LinkQrCode,
		CountDown
	  },
	  data() {
	    return {
           centerDialogVisible:false,
		   payDialogVisible:false,
		   payLink:'',
		   payTimer:null,
		   oId:"",
		   invoice_price:"",
		   ruleForm:{
			   company_name: '',
			   tax_id:'',
			   email:"",
		   },
		   paybox:"",
		   user:"",
		   rules: {
				 company_name: [
				   { required: true, message: '请输入公司信息', trigger: 'blur' },
				 ],
				 tax_id: [
				   { required: true, message: '请输入公司税号', trigger: 'blur' }
				 ],
				 email: [
				   { required: true, message: '邮件不能为空', trigger: 'blur' }
				 ],
			}
	    }
	  },
	  props:{
	  	list:{}
	  },
	  created() {
	  	
	  },
	  watch: {
		payDialogVisible(val) {
			if (!val) {
				this.clearPayTimer()
			}
		}
	  },
	  beforeDestroy() {
		this.clearPayTimer()
	  },
	  deactivated() {
		this.clearPayTimer()
	  },
	  beforeRouteLeave(to, from, next) {
		this.clearPayTimer()
		next()
	  },
	  methods: {
		getinvoicePrice(){
		  	invoicePrice(this.oId,{
				
			}).then(res=>{
		  		this.invoice_price=res.data.data.invoice_price
		  	})
		},
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				console.log(valid)
				if (valid) {
					this.submit()
				} else {
					return false;
				}
			});
		},
		// 添加开票
		submit(){
			InvoiceApply(this.oId,{
				...this.ruleForm
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功');
					this.centerDialogVisible=false  
					this.$emit('gengxin',"0")
				}else{
					this.$message.success(res.data.msg);
				}
			})  
		},
		//支付
		pay(i){
			this.paybox=i
			OrderPay({
				order_sn:i.order_sn,
				pay_type:'NATIVE'
			}).then(res=>{
				const payLink = res.data.data.code_url
				if (!payLink) {
					this.$message.error('未获取到支付链接')
					return
				}
				this.payLink = payLink
				this.payDialogVisible = true
				this.setpayStatus(this.paybox)
			})
		},
		clearPayTimer(){
			if (this.payTimer) {
				clearInterval(this.payTimer)
				this.payTimer = null
			}
		},
		// 支付轮询
		setpayStatus(e){
			this.clearPayTimer()
			this.payTimer = setInterval(() => {
				payStatus({
					order_sn:e.order_sn,
					order_type:"1"
				}).then(res=>{
					if (this.isPaySuccess(res)) {
						this.$message.success('支付成功')
						this.payDialogVisible = false
						this.clearPayTimer()
						this.$emit('gengxin',"0")
					}
				})
			}, 2000)
		},
		isPaySuccess(res){
			const data = res && res.data ? res.data : {}
			const payload = data.data || {}
			return (
				data.status === 200 &&
				(
					payload.pay_status === 1 ||
					payload.status === 1 ||
					payload.is_pay === 1 ||
					payload.paid === true
				)
			)
		},
		
		kaipiao(e){
			this.oId=e
			this.getpersonal()
			this.getinvoicePrice()
			this.centerDialogVisible=true  
		},
		// 查看开票
		chakana(e){
			const targetPath = '/demandHome/demandOrder/orderInvoice?oid='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		getpersonal(){
			personal({}).then(res=>{
				this.user=res.data.data
				this.ruleForm.company_name=this.user.company_name
				this.ruleForm.tax_id=this.user.tax_id
				this.ruleForm.email=this.user.email
			})
		},
		datails(e){
			const targetPath = '/demandHome/demandOrder/orderDatalis?oid='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		pingshen(e){
			const targetPath = '/demandHome/demandOrder/Reviewdatails?oid='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		liuyan(e,status){
			const targetPath = '/demandHome/demandOrder/AddMessage?oid='+e+"&status="+status
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>

<style scoped>
	.orderbox{
		width:1200px;
		margin:0 auto;
		overflow: hidden;
	}
	.orderbox>div:nth-child(3n){
		margin-right:0px;
	}
	.liebiao1{
		width:384px;
		height:176px;
		float: left;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		margin-bottom:24px;
		margin-right:24px;
		padding:12px;
		box-sizing: border-box;
		cursor:pointer;
		transition: all 0.3s;
	}
	.liebiao1:hover{
		transform: scale(1.03);
	}
	.orderTitle{
		width:100%;
		display:flex;	
	    justify-content:space-between;
		align-items: center;
	}
	.orderTitle h3{
		width:260px;
		overflow: hidden;
		text-overflow: ellipsis; 
		white-space: nowrap; 
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.orderTitle span{
		font-weight: bold;
		font-size: 14px;
	}
	.orderbh1{
		font-weight: 500;
		font-size: 12px;
		color: #999999;
		margin-top:10px;
	}
	.orderbh2{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
		margin-top:10px;
	}
	.orderbh2 span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.orderbh3{
		font-weight: 500;
		font-size: 14px;
		color: #FF5900;
		margin-top:10px;
	}
	.orderbh3 span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.orderbh4{
		width:100%;
		margin-top:12px;
		display:flex;
		justify-content:end;
	}
	.orderbh4_1{
		text-align: center;
		min-width:76px;
		padding:6px;
		box-sizing: border-box;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		margin-left:15px;
		position:relative;
	}
	.orderbh4_2{
		text-align: center;
		min-width:76px;
		padding:6px;
		box-sizing: border-box;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
		margin-left:15px;
	}
	.pay-tip{
		margin-top: 12px;
		text-align: left;
		color: #666;
		font-size: 14px;
		display:flex;
		align-items: center;
		margin-top:15px;
	}
	.pay-tip h3{
		font-weight: bold;
		font-size: 19rpx;
		color: #333333;
		margin-right:10px;
	}
	.pay-tip span{
		font-weight: 400;
		font-size: 13rpx;
		color: #666666;
	}
	.pay-box{
		width:100%;
		height:120px;
		display:flex;
		margin-top:10px;
	}
	.pay-box1{
		margin-left:10px;
	}
	.pay-box1 p{
		color: #FF5900;
	}
	.pay-box2{
		margin-top:30px;
	}
	.pay-box2 h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.pay-box2 span{
		font-weight: 800;
		font-size: 24px;
		color: #FF5900;
	}
</style>